import { retry } from '@color/lib';

export async function polyfillDateTimeFormatTimezone() {
  if (!window.Intl?.DateTimeFormat) {
    // This is about 2.85 MiB
    // @ts-expect-error: Could not find a declaration file for module
    await retry(() => import('date-time-format-timezone'));
  }
}
